<ion-card class="question-card">

  <ion-card-header>
    @if (to.label) {
    <div class="ion-text-wrap ion-font-md ion-font-weight-medium ion-card-title-patch">
      <ion-label color="dark">{{ to.label }}</ion-label>
      @if (field.ta_validators?.required || field.ta_validators?.checkboxRequired) {
      <ion-text color="danger">*</ion-text>
      }
    </div>
    }
    @if (field.props.prepopulate?.prepopulateFromAsset || field.props.prepopulate?.updateAssetFromAudit) {
    <ion-card-subtitle class="ion-margin-top-1" mode="md" color="secondary">
      {{field.props.prepopulate.prepopulateFromAsset && field.props.prepopulate.updateAssetFromAudit ?
      'Pre-populate from and update ' : field.props.prepopulate.prepopulateFromAsset &&
      !field.props.prepopulate.updateAssetFromAudit ? 'Pre-populate from ': 'Update ' }}
      "{{field.props.prepopulate.assetType}}" asset
    </ion-card-subtitle>
    }
    @if (field.props.autoIncrement?.increment) {
    <ion-card-subtitle class="ion-margin-top-1" mode="md" color="secondary">
      Auto-incremented by {{field.props.autoIncrement.value}} {{field.props.autoIncrement.unit}}
    </ion-card-subtitle>
    }
    <app-question-guidance [props]="$any(props)"></app-question-guidance>
  </ion-card-header>

  <ng-template #fieldComponent></ng-template>

</ion-card>